import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-projects6',
  templateUrl: './section-projects6.component.html',
  styleUrls: ['./section-projects6.component.css']
})
export class SectionProjects6Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
